var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.clamp)?_c('span',[_vm._v(_vm._s(_vm.smartName))]):_c('v-clamp',{attrs:{"autoresize":"","max-lines":_vm.maxLines}},[_vm._v("\n    "+_vm._s(_vm.smartName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }